import React from 'react';
import { Bell, HelpCircle, Home, LogOut, UserCircle } from 'lucide-react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';
import { hubUrl } from '../utils/hubUrl';
import BugReporter from './BugReporter';
import ThemeToggle from './ThemeToggle';

export default function TopBar() {
  const location = useLocation();
  const { ready, email, isAdmin } = useAuth();

  const showHelp = location.pathname.startsWith('/portal');

  return (
    <header className="topbar">
      <div className="topbar-left">
        {/* Home button hidden until the hub apex (botfield.ai) is wired. The
            `false &&` guard keeps hubUrl/Home referenced so the build doesn't
            flag them unused; drop the guard when the hub is prod-ready. */}
        {false && (
        <a
          className="btn"
          href={hubUrl()}
          title="Return to the Botfield Suite hub"
          style={{ padding: '6px 10px' }}
        >
          <Home size={15} />
          Home
        </a>
        )}
        {isAdmin ? <span className="badge">Admin</span> : null}
      </div>

      <BugReporter />

      <ThemeToggle />

      <button className="icon-btn" title="Notifications" type="button" aria-label="Notifications">
        <Bell size={18} />
      </button>

      <button
        className="icon-btn"
        title={showHelp ? 'Help (coming soon)' : 'Help'}
        type="button"
        aria-label="Help"
        onClick={() => {
          // Placeholder: in the reference app this opens a modal.
          // We keep it as a non-blocking stub for Phase 1.
          // eslint-disable-next-line no-alert
          alert('Help is coming soon.');
        }}
      >
        <HelpCircle size={18} />
      </button>

      <div className="badge" title={ready ? email : 'Loading user…'}>
        <UserCircle size={16} />
        <span style={{ maxWidth: 240, overflow: 'hidden', textOverflow: 'ellipsis' }}>
          {ready ? (email || 'Unknown user') : '…'}
        </span>
      </div>

      <a className="icon-btn" title="Logout" aria-label="Logout" href="/.auth/logout?post_logout_redirect_uri=/.auth/login/aad%3Fprompt%3Dlogin">
        <LogOut size={18} />
      </a>
    </header>
  );
}
